var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{staticClass:"flex-align-center"},[_c('FeatureIconsCard',{staticClass:"mr-3",attrs:{"flowData":_vm.flowData}}),_c('Col',{staticClass:"flex-justify-center"},[_c('Col',{staticClass:"workflow-title"},[_c('h3',{staticClass:"one-row"},[_vm._v(_vm._s(_vm.issue.error_message))]),_c('h4',[_vm._v("Issue in: "+_vm._s(_vm.flowData.title))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }